import { useMatches } from 'react-router-dom';

/** Route `handle` fields AppLayout reads. */
export interface AppRouteHandle {
    /** `full-width`: AppLayout renders the page without PageContainer; the page places its own. */
    pageLayout?: 'full-width';
}

export const FULL_WIDTH_PAGE: AppRouteHandle = { pageLayout: 'full-width' };

export function useIsFullWidthPage(): boolean {
    return useMatches().some((match) => (match.handle as AppRouteHandle | undefined)?.pageLayout === 'full-width');
}
